import { render, staticRenderFns } from "./transfer-user.vue?vue&type=template&id=dacfa7cc"
import script from "./transfer-user.vue?vue&type=script&lang=js"
export * from "./transfer-user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports